import BaseController from "controllers/base"

class Controller extends BaseController {
  call() {
    bindShowLinks.call(this)
  }
};

let bindShowLinks = function() {
  this.root.find('.enquiry-item').on('click', (e) => {
    window.location = e.currentTarget.dataset.url
  })
}

export default Controller;
